import { getTherapeuticMaterialFamilyForActKind, } from "./TherapeuticChoicesFees.js";
import { implantAbutmentActLabelsByCode, implantPlacementActLabelsByCode, } from "./ImplantActLabels.js";
import { knownDentalCcamActes } from "../filterTransforms/ccam/knownDentalCcamActes.js";
// MVP mapping: covers implant, implant-crown, and inlay-core material families.
// Extensible: add explicit entries here as new act kinds become needed.
const explicitCcamCodeToActKind = {
    ...Object.fromEntries(Object.keys(implantAbutmentActLabelsByCode).map((code) => [
        code,
        "implant_abutment",
    ])),
    ...Object.fromEntries(Object.keys(implantPlacementActLabelsByCode).map((code) => [
        code,
        "implant",
    ])),
    HBLD418: "crown",
    HBLD734: "crown",
    HBLD090: "core",
    HBLD745: "core",
    HBLD245: "core",
};
export function ccamCodeToActKind(ccamCode) {
    if (!ccamCode) {
        return null;
    }
    const explicit = explicitCcamCodeToActKind[ccamCode];
    if (explicit) {
        return explicit;
    }
    // Fallback heuristic based on the known dental act label vocabulary.
    // Kept conservative: only matches implant-related acts for now,
    // which are the only ones that drive a material selection downstream.
    const known = knownDentalCcamActes.find((acte) => acte.code === ccamCode);
    if (!known) {
        return null;
    }
    const label = known.label.toLowerCase();
    if (label.includes("pilier") && label.includes("implant")) {
        return "implant_abutment";
    }
    if (label.startsWith("pose ") && label.includes("implant")) {
        return "implant";
    }
    return null;
}
export function getTherapeuticMaterialFamilyForCcamCode(ccamCode) {
    if (ccamCode === "HBLD418") {
        return "implantCrown";
    }
    const kind = ccamCodeToActKind(ccamCode);
    return kind ? getTherapeuticMaterialFamilyForActKind(kind) : null;
}
//# sourceMappingURL=ActKindMapping.js.map